import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CreditCard } from '../../../models/payment/credit-card.model';

@Component({
  selector: 'aum-cli-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss']
})
export class CreditCardComponent {
  @Input() creditCard: CreditCard;
  @Input() deleteMode = false;
  @Output() clickCard = new EventEmitter();

  constructor() {}

  onCardClick() {
    this.clickCard.emit();
  }
}
